export default "__VITE_ASSET__CRrBtaNU__"